/*
 * File: /src/services/voiceServices.js
 * Created Date: Sunday May 23rd 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 23rd May 2021 11:03:48 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */
import { authedAxios } from '../shared/axiosWrapper';
import {
  AD_BASE_VOICE_SERVICES_PATH,
  AD_BASE_VOICE_PATH,
  AD_BASE_DIRECT_DIAL_PATH,
} from '../constants';

export default {

  // Short lived until websockets send this info
  getCallData(segmentSid) {
    return authedAxios.get(AD_BASE_VOICE_PATH + 'call/' + segmentSid);
  },

  getActiveCalls() {
    return authedAxios.get(AD_BASE_VOICE_PATH + 'active-calls/');
  },

  getActiveSegments() {
    return authedAxios.get(AD_BASE_VOICE_PATH + 'active-segments/');
  },
  /**
   * Call contact
   * TODO move this to voice service
   * @param {*} contactId
   * @param {string} [method='mobile']
   * @param {number} [serviceId=0]
   * @returns
   */
  callContact(contactId, toNumber, fromNumberId) {
    const data = {
      contactId: contactId,
      toNumber: toNumber,
      fromNumberId: fromNumberId,
    };
    return authedAxios.post(AD_BASE_VOICE_PATH + 'call/', data);
  },

  dialNumber(toNumber, fromNumberId) {
    const data = {
      toNumber: toNumber,
      fromNumberId: fromNumberId,
    };
    return authedAxios.post(AD_BASE_VOICE_PATH + 'dial/', data);
  },

  completeCall(callId, callResultId, leadId, dispositionId) {
    return authedAxios.post(AD_BASE_VOICE_PATH + 'complete-call/', {
      callId: callId,
      resultTypeId: callResultId,
      leadId: leadId,
      dispositionId: dispositionId
    });
  },

  fetchCallResults() {
    return authedAxios.get(AD_BASE_VOICE_SERVICES_PATH + 'call-results',
      {params: {sort: 'display_order:asc'}})
  },

  fetchCallStatus() {
    return authedAxios.get(AD_BASE_VOICE_SERVICES_PATH + 'call-status');
  },


  fetchMenus() {
    return authedAxios.get(AD_BASE_VOICE_SERVICES_PATH + 'menus');
  },

  fetchMenu(id) {
    return authedAxios.get(AD_BASE_VOICE_SERVICES_PATH + 'menus/' + id);
  },

  updateMenu(id, payload) {
    return authedAxios.put(AD_BASE_VOICE_SERVICES_PATH + 'menus/' + id, payload);
  },

  createMenu(payload) {
    return authedAxios.post(AD_BASE_VOICE_SERVICES_PATH + 'menus/', payload);
  },

  deleteMenu(id) {
    return authedAxios.delete(AD_BASE_VOICE_SERVICES_PATH + 'menus/' + id);
  },

  fetchVoicemailBoxes() {
    return authedAxios.get(AD_BASE_VOICE_SERVICES_PATH + 'mailboxes');
  },

  fetchDirectDial(id) {
    return authedAxios.get(AD_BASE_DIRECT_DIAL_PATH + id );
  },
  fetchDirectDials() {
    return authedAxios.get(AD_BASE_DIRECT_DIAL_PATH );
  },
  updateDirectDial(id, payload) {
    return authedAxios.put(AD_BASE_DIRECT_DIAL_PATH + id, payload);
  },

  createDirectDial(payload) {
    return authedAxios.post(AD_BASE_DIRECT_DIAL_PATH, payload);
  },
};
